import { render, staticRenderFns } from "./PersonalizedGameEditorImage.vue?vue&type=template&id=4c728e0c&"
import script from "./PersonalizedGameEditorImage.vue?vue&type=script&lang=js&"
export * from "./PersonalizedGameEditorImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports